/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);a[_ngcontent-%COMP%]{color:#3d516f}.folder-nav[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:10px 0 25px}.folder-nav[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{font-size:.75rem;min-width:145px}.previous[_ngcontent-%COMP%]{text-align:center;color:#327253;text-decoration:underline;cursor:pointer;padding:17px}"];
export { styles as styles };
